<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (canCreatePoints$ | async) {
  <button mat-button (click)="addPoint(layerName)">
    {{ buttonText }}
  </button>
}
